import { useCallback } from "react";

import { useGetIndustriesQuery } from "@/pages/Private/redux/companyEnrich/companyEnrich.api";
import { useLazyGeSuggestionQuery } from "@/pages/Private/redux/liPeople/liPeople.api";
import { useLazyGetOnboardingIcpQuery } from "@/pages/Private/redux/onboardingIcp/onboardingIcp.api";

import { resolveIcpLocation } from "./resolveIcpLocation";

/**
 * Warms the lookups the lists step blocks on before seeding its rows, so the
 * picker can be prefilled the moment it mounts instead of a few seconds in
 * (PREC-3719). The chat calls the returned starter on its way to the step; the
 * picker then repeats the same reads with `preferCacheValue` and hits the cache
 * (or, when a request is still in flight, awaits that one instead of a second).
 *
 * The recommendation itself is not warmed here — the chat already fetched it to
 * preview the two lists it is handing over.
 */
export const useOnboardingListsPrewarm = (): (() => void) => {
	// Subscribing loads the industry lookup whose NAICS codes the picker needs
	// before it can apply a recommended industry as a filter.
	useGetIndustriesQuery();

	const [fetchIcp] = useLazyGetOnboardingIcpQuery();
	const [fetchLocationSuggestions] = useLazyGeSuggestionQuery();

	return useCallback(() => {
		const warm = async () => {
			try {
				const icp = await fetchIcp().unwrap();

				await resolveIcpLocation(icp.location, fetchLocationSuggestions);
			} catch (err) {
				console.error(err);
			}
		};

		// Fire-and-forget: the chat must not wait for it before navigating.
		warm();
	}, [fetchIcp, fetchLocationSuggestions]);
};
